<template>
  <div class="page-segment">
    <div class="wrap">
      <a-page-header class="header" title="不正常航班证明" />
      <div class="tips" v-if="cmsData.delayTips" v-html="cmsData.delayTips"></div>
      <div class="block">
        <div class="title">请输入乘机人信息</div>
        <div class="search-wrap">
          <a-form
            layout="horizontal"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :colon="false"
            :form="form"
          >
            <a-row>
              <a-col :span="24">
                <a-form-item required label="乘机人姓名">
                  <a-input
                    size="large"
                    placeholder="请填写乘机人姓名"
                    allowClear
                    v-decorator="[
                      'name',
                      {
                        rules: [
                          {
                            validator: onValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item required label="证件号码">
                  <a-input
                    size="large"
                    placeholder="请输入您的证件号码"
                    allowClear
                    v-decorator="[
                      'number',
                      {
                        rules: [
                          {
                            validator: onValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item required label="客票号码">
                  <a-input
                    size="large"
                    placeholder="请输入您的13位客票号码"
                    allowClear
                    v-decorator="[
                      'ticketNo',
                      {
                        rules: [
                          {
                            validator: onValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item required label="航班日期">
                  <a-date-picker
                    value-format="YYYY-MM-DD"
                    placeholder="请选择航班日期"
                    size="large"
                    :disabled-date="disabledDate"
                    :locale="locale"
                    v-decorator="[
                      'flightDate',
                      {
                        initialValue: moment().format('YYYY-MM-DD'),
                        rules: [
                          {
                            validator: onValidate
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                  </a-date-picker>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <a-row>
            <a-col :offset="5" :span="18">
              <div class="mod-submit">
                <div class="agreement" v-if="cmsData.delayAgreement && cmsData.delayAgreement.length">
                  <AgreementTrack
                    :checked="agreement"
                    :cmsId="agreeListModuleId"
                    description='不正常航班查询页'
                    pageName='delay_flight_query'
                    @change="e => agreement = e"
                  >
                  {{ `我已阅读并理解${airName}` }}
                    <template v-for="(item, index) in cmsData.delayAgreement">
                      <span class="link" v-if="isThirdUrl(item.url)" :key="index" @click="goThirdUrl(item.url)">{{ item.name }}{{ index === (cmsData.delayAgreement.length - 1) ? '' : '，'}}</span>
                      <router-link v-else :to="item.url" :key="index" target="_blank">{{ item.name }}{{ index === (cmsData.delayAgreement.length - 1) ? '' : '，'}}</router-link>
                    </template>
                  </AgreementTrack>
                </div>
                <a-button type="primary" size="large" :loading="loading" @click="search">查询</a-button>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="block" v-if="flightArr.length">
        <div class="title">请选择航班</div>
        <div class="content">
          <a-table
            rowKey="ticket"
            :columns="columns"
            :data-source="flightArr"
            :pagination="false"
            :customRow="customRow"
          >
            <a-radio slot="radio" slot-scope="checked" :checked="checked"></a-radio>
          </a-table>
        </div>
      </div>
      <div class="nodata" v-if="!flightArr.length && isSearch && cmsData.delayNoDataTips">
        <div class="text" v-html="cmsData.delayNoDataTips"></div>
      </div>
      <div class="block" v-if="selectIndex !== null">
        <div class="title">开具不正常航班证明</div>
        <div class="content mail">
          <p>您好，请填写邮箱地址点击“发送邮件”接收证明或直接下载不正常航班证明</p>
          <div class="clearfix">
            <a-row type="flex" justify="space-between">
              <a-col :span="18">
                <a-form
                  layout="inline"
                  :label-col="{ style: 'width: 70px' }"
                  :wrapper-col="{ style: 'width: 574px' }"
                  :form="mailForm"
                  @submit="sendMail"
                >
                  <a-form-item label="邮箱地址：">
                    <a-input
                      size="large"
                      placeholder="请输入邮箱地址"
                      allowClear
                      v-decorator="[
                        'email',
                        {
                          rules: [
                            { required: true, message: '请输入邮箱地址' },
                            { pattern: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i, message: '请输入正确的邮箱地址' }
                          ],
                          validateTrigger: 'blur'
                        }
                      ]"
                    >
                    </a-input>
                  </a-form-item>
                </a-form>
              </a-col>
              <a-col :span="6">
                <div class="btn-group">
                  <a-button class="send" type="default" :loading="sendLoading" @click="sendMail">发送邮件</a-button>
                  <a-button class="download" type="primary" :loading="downloadLoading" @click="download">下载</a-button>
                </div>
              </a-col>
            </a-row>
          </div>
          <a-popover v-if="cmsData.delayNoMailTips" title="收不到不正常航班证明？" placement="bottomLeft">
            <template slot="content">
              <div v-html="cmsData.delayNoMailTips"></div>
            </template>
            <span class="pop">收不到不正常航班证明？</span>
          </a-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import moment from 'moment'
import { cloneDeep } from 'lodash'
import { validate } from '@/assets/js/validate'
import getAppInfo from '@/utils/from'
import { queryDelayFlight, sendEmail, sendImgData } from '@/apis/delay'
import AgreementTrack from '@/components/agreement-track'
import './index'

const columns = [
  {
    title: '航班号',
    dataIndex: 'flightNo',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '始发地',
    dataIndex: 'dep',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '目的地',
    dataIndex: 'arr',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '旅客姓名',
    dataIndex: 'name',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '计划起飞',
    dataIndex: 'stdLocal',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '计划到达',
    dataIndex: 'staLocal',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '可开具证明类型',
    dataIndex: 'certificateType',
    className: 'col-title',
    ellipsis: true
  },
  {
    title: '',
    dataIndex: 'radio',
    className: 'col-title',
    width: 60,
    scopedSlots: { customRender: 'radio' }
  }
]

export default {
  data () {
    return {
      tipContent: '',
      tipMail: '',
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      locale,
      form: this.$form.createForm(this, { name: 'delay' }),
      mailForm: this.$form.createForm(this, { name: 'mail' }),
      agreement: false,
      loading: false,
      isSearch: false,
      columns,
      flightList: [],
      flightArr: [],
      selectIndex: null,
      downloadLoading: false,
      sendLoading: false,
      cmsData: {},
      airName: getAppInfo()?.name,
      hotline: getAppInfo()?.hotline,
      airline: window.__MICRO_ROOT__?.airline || ''
    }
  },
  created () {
    this.getCmsData()
  },
  methods: {
    moment,
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then((res) => {
          this.cmsData = {
            delayTips: res?.delayTips?.content || '',
            delayNoMailTips: res?.delayNoMailTips?.content || '',
            delayNoDataTips: res?.delayNoDataTips?.content || '',
            delayAgreement: res?.delayAgreement?.list || [],
            agreeListModuleId: res?.delayAgreement?._moduleId || ''
          }
        })
      } catch (err) {}
    },
    isThirdUrl (url) {
      return url.includes('http')
    },
    onValidate (rule, value, callback) {
      validate('delay-infomation', this.form.getFieldsValue(), rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    search () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          const { cmsData, agreement, airName } = this
          if (cmsData.delayAgreement && cmsData.delayAgreement.length && !agreement) {
            this.$error({
              content: `请阅读${airName}相关协议`,
              centered: true
            })
            return
          }
          this.getFlights(values)
        }
      })
    },
    async getFlights (values) {
      const { airline, hotline, airName } = this
      this.loading = true
      try {
        const params = {
          ...values,
          carrier: airline
        }
        const data = await queryDelayFlight(params)
        this.selectIndex = null
        this.loading = false
        this.flightList = data || []
        this.flightArr = cloneDeep(this.flightList)
        this.isSearch = !this.flightList.length
        let noDataMessage = '暂无数据'
        if (airline === '8L') {
          noDataMessage = `暂未查询到不正常航班数据，如有疑问可致电${airName}官方客服热线${hotline}咨询。`
        }
        !this.flightList.length && this.$message.error(noDataMessage)
      } catch (err) {
        this.loading = false
        this.$message.error(err.message || '查询失败，请稍后再试')
      }
    },
    disabledDate (current) {
      return current < moment().subtract(2, 'years').subtract(1, 'day') || current > moment().add(2, 'years')
    },
    customRow (record, index) {
      return {
        on: {
          click: () => {
            this.flightArr.forEach(row => {
              this.$set(row, 'radio', false)
            })
            record.radio = true
            this.selectIndex = index
          }
        }
      }
    },
    sendMail () {
      this.mailForm.validateFields(async (err, values) => {
        if (err) {
          return
        }
        this.sendLoading = true
        try {
          const params = {
            ...this.flightList[this.selectIndex],
            email: values.email
          }
          await sendEmail(params)
          this.sendLoading = false
          this.$router.push({
            path: '/delay/response',
            query: { type: 'success' }
          })
        } catch (err) {
          this.sendLoading = false
          this.$message.error(err)
          setTimeout(() => {
            this.$router.push({
              path: '/delay/response',
              query: { type: 'fail' }
            })
          }, 3000)
        }
      })
    },
    async download () {
      this.downloadLoading = true
      try {
        const params = {
          ...this.flightList[this.selectIndex]
        }
        const data = await sendImgData(params)
        this.downloadLoading = false
        if (data.imgData) {
          const base64 = `data:image/png;base64,${data.imgData}`
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = '不正常航班证明'
            elink.style.display = 'none'
            elink.href = base64
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            const bstr = atob(base64.split(',')[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }
            const blob = new Blob([u8arr])
            navigator.msSaveBlob(blob, '不正常航班证明.png')
          }
          const net = window.open(base64)
          net.addEventListener('beforeunload', () => {
            this.$router.push({
              path: '/delay/response',
              query: { type: 'success' }
            })
          })
        } else {
          this.$router.push({
            path: '/delay/response',
            query: { type: 'fail' }
          })
        }
      } catch (err) {
        this.downloadLoading = false
        this.$message.error(err.message)
      }
    },
    goThirdUrl (url) {
      open(url, '_blank')
    }
  },
  components: {
    AgreementTrack
  }
}
</script>

<style lang="less" scoped>
  .page-segment {
    ::v-deep .ant-form-explain {
      margin-top: 0;
    }
  }
</style>
